export function handleImageFileConversion(
  file,
  handleError,
  handleSuccess,
  MAX_DIMENSION = 150
) {
  const reader = new FileReader();
  reader.onerror = (e) => {
    handleError(e);
    reader.abort();
  };
  reader.onload = (e) => {
    const image = document.createElement('img');
    image.onload = () => {
      const canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');

      if (image.height > MAX_DIMENSION) {
        image.width *= MAX_DIMENSION / image.height;
        image.height = MAX_DIMENSION;
      } else if (image.width > MAX_DIMENSION) {
        image.height *= MAX_DIMENSION / image.width;
        image.width = MAX_DIMENSION;
      }

      canvas.width = image.width;
      canvas.height = image.height;
      ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      handleSuccess(canvas.toDataURL());
    };
    image.src = e.target.result;
  };
  reader.readAsDataURL(file);
}

export function handleFileRead(file, handleError, handleSuccess) {
  const reader = new FileReader();
  reader.onerror = (e) => {
    handleError(e);
    reader.abort();
  };

  reader.addEventListener(
    'load',
    () => {
      // result will look like "data:*/*;base64," so we get only the base64 string after the comma
      handleSuccess(reader.result.split(',')[1]);
    },
    false
  );

  reader.readAsDataURL(file);
}
